import script from "./verificationRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./verificationRequests.vue?vue&type=script&setup=true&lang=js"

import "./verificationRequests.vue?vue&type=style&index=0&id=189b7cbc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189b7cbc"]])

export default __exports__